import React from 'react';
import { Grid, Typography, useTheme, Box } from '@mui/material';
import OneWayWs from './OneWayWs';
import RoundTrip from './RoundTripWs';
import { getResultsStyles } from './resultsStyles';

const ResultsState = ({
  touchDirection,
  handleTouchStart,
  onEndHandler,
  search_type,
  props,
  selectAirline,
}) => {
  const theme = useTheme();
  const styles = getResultsStyles(theme);

  const FlightMatrixView = ({ search_type, props }) => {
    if (search_type === 'OneWay') return <OneWayWs {...props} />;
    if (search_type === 'RoundTrip') return <RoundTrip {...props} />;
    return null;
  };

  return (
    <>
      <Typography sx={styles.bestPriceText}>
        <Box
          component="img"
          src={require(`@shared/assets/ThreeDays/check.svg`)?.default}
          alt="check img"
          sx={styles.checkImage}
        />
        Mejor Precio sugerido
      </Typography>

      <Box
        sx={{
          ...styles[touchDirection + 'Shadow'],
          overflowX: { xs: 'scroll', sm: 'scroll', md: 'visible' },
          overflowY: { xs: 'hidden', sm: 'hidden', md: 'visible' },
          maxWidth: { xs: '90vw', sm: '95vw', md: '100%' },
        }}
      >
        <Grid
          container
          sx={{ flexWrap: 'nowrap', backgroundColor: '#EAEAEA' }}
          onTouchStart={handleTouchStart}
          onTouchMove={onEndHandler}
          style={{
            minWidth: '900px',
          }}
        >
          <FlightMatrixView search_type={search_type} props={props} />
        </Grid>
      </Box>

      {selectAirline}
    </>
  );
};

export default ResultsState;
